import Vue from 'vue'
import { mapState } from 'vuex'
import { jobPartiesMixin } from '../mixins'

export default Vue.extend<any, any, any, any>({
  mixins: [jobPartiesMixin],
  computed: {
    ...mapState({
      application: (state: any) => state.jobChat.application.value,
    }),
    inProgress() {
      return Boolean(this.application?.wasStarted)
    },
  },
})
